module.exports = __webpack_public_path__ + "static/media/faza3_AL.9bc87159.svg";